<template>
	<div class="container-fluid flex-column position-absolute justify-content-center h-100 main" id="updatePopup">
		<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 flex-wrap">
			<div class="container align-items-start justify-content-between ">
				<label for="hostname"
				       class="label">hostname</label>
				<input class="input"
				       type="text"
				       id="hostname"
				       v-model="updatedStreamerStr.hostname"
				       autocomplete="off"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="address"
				       class="label">address</label>
				<input class="input"
				       type="text"
				       v-model="updatedStreamerStr.address"
				       id="address"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="multiplier"
				       class="label">multiplier</label>
				<input class="input"
				       type="text"
				       v-model="updatedStreamerStr.multiplier"
				       id="multiplier"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="maxlimit"
				       class="label">maxlimit</label>
				<input class="input"
				       type="text"
				       v-model="updatedStreamerStr.maxlimit"
				       id="maxlimit"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="live"
				       class="label">live</label>
				<input class="input"
				       type="text"
				       v-model="updatedStreamerStr.live"
				       id="live"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="mysql_port"
				       class="label">mysql_port</label>
				<input class="input"
				       type="text"
				       v-model="updatedStreamerStr.mysql_port"
				       id="mysql_port"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="login"
				       class="label">login</label>
				<input class="input"
				       type="text"
				       id="login"
				       v-model="updatedStreamerStr.login"
				       autocomplete="off"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="password"
				       class="label">password</label>
				<input class="input"
				       type="text"
				       v-model="updatedStreamerStr.password"
				       id="password"></div>
			<div class="container  align-items-start justify-content-between "
			     v-show="false">
				<label for="operator"
				       class="label">operator</label>
				<select name="operator"
				        class="input"
				        id="operator"
				        :disabled="true"
				        v-model="updatedStreamerStr.operator">
					<option v-for="operator in operators"
					        :value="operator.name"
							:key="operator.name">{{operator.display_name}}</option>
				</select>
			</div>
			<div class="container  align-items-start justify-content-end mt-3">
				<button @click="update"
				        class="btn btn-outline-success">изменить
				</button>
				<button @click="cancel"
				        class="btn btn-outline-danger ml-4">отменить
				</button>
			</div>
			<transition enter-active-class="animated fadeInUp"
			            leave-active-class="animated fadeOutDown">
				<p class="text-danger mb-0 pb-0 position-absolute popup" v-if="correct">{{ messageError }}</p>
			</transition>
		</div>
	</div>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapGetters }     from "vuex";

	export default {
		name:     "UpdateStreamer",
		data() {
			return {
				operators:    [],
				oneOperators: "",
				correct:      false,
				messageError: ""
			};
		},
		props:    {
			updatedStreamerHost: String,
			updatedStreamerStr:  Object
		},
		beforeMount() {
			// this.oneOperators = a.data.operator;
			if (this.getReqUserRole === "Администратор уровня Бог") {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "getOperatorList"
					},
					null,
					a => {
						if (a.code === 200) {
							this.operators = a.data;

						} else {
							console.log("ошибка при получении жанров");
						}

					});
			}

		},
		methods:  {
			cancel() {
				this.$emit("cancel");
			},
			errorHandler(value) {
				this.messageError = value;
				if (!this.correct) {
					this.correct = true;
					setTimeout(() => {
						this.correct = false;
					}, 2500);
				}
			},
			update() {
				performRequest(
					{
						section: "tvcontent.streamer",
						name:    "updateStreamer"
					},
					{
						...this.updatedStreamerStr,
						old_hostname: this.updatedStreamerHost,
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							console.log(a);
							this.cancel();
						} else if (a.code === 400) {
							this.errorHandler("введены не корректные данные");
						} else if (a.code === 500) {
							this.errorHandler("ошибка на сервере, либо переданы невалидные данные");
						} else {
							console.log("ошибка =(((");
						}

					}
				);
			}
		},
		computed: {
			...mapGetters(["getReqUserRole", "getViewUser"])
		},
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	div {
		display: flex;
	}
	.main {
		z-index: 1000;
		background-color: rgba(130, 130, 130, 0.27);
	}
	.input {
		width: 70%;
		outline: none;
		min-height: 1.8rem;
		border: 1px solid gray;
		border-radius: 3px;
		transition: all .3s;
		padding-left: 5px;
		&:focus {
			border: 1px solid #acafff;
			box-shadow: 0 0 7px #acafff;
		}
	}
	.label {
		width: 100px;
	}
	.popup {
		bottom: 1.5rem;
		font-size: 1.1rem;
		left: 3.8rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/UpdateStreamer.vue